import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IMapPopup } from './map-popup.types';

@Component({
  selector: 'app-map-popup',
  templateUrl: './map-popup.component.html',
  styleUrl: './map-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MapPopupComponent {
  @Input() data: IMapPopup;

  constructor() {}
}
